import React, { useState, useEffect, useContext } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from '@mui/styles';
import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions"
import Grid from '@mui/material/Grid';
import Button from "components/CustomButtons/Button.js";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import { api } from 'common';
import { ThemeContext } from "components/Theme/ThemeContext";

const useStyles = makeStyles(theme => ({
    tabs: {
        "& .MuiTabs-indicator": {
            backgroundColor: "#E9AE31",
            height: 3,
        },
        "& .MuiTab-root": {
            color: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.6)" : "rgba(15, 23, 42, 0.6)",
            fontSize: "15px",
            fontWeight: "600",
            textTransform: "none",
            transition: "all 0.3s ease",
            fontFamily: 'Outfit, sans-serif'
        },
        "& .MuiTab-root.Mui-selected": {
            color: '#E9AE31',
            textShadow: "0 0 10px rgba(233, 174, 49, 0.25)"
        }
    },
    buttonStyle: {
        background: 'linear-gradient(135deg, #FFD066 0%, #E9AE31 50%, #C28F1B 100%) !important',
        color: '#0A0A0B !important',
        borderRadius: "50px !important",
        height: 48,
        textTransform: 'none',
        fontSize: '15px',
        fontWeight: "700 !important",
        boxShadow: '0 4px 15px rgba(233, 174, 49, 0.25) !important',
        marginTop: 20,
        padding: "0 32px !important",
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important',
        '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 6px 20px rgba(233, 174, 49, 0.4) !important',
            background: 'linear-gradient(135deg, #FFE08C 0%, #F5C242 50%, #D69E2E 100%) !important',
        },
        '&:active': {
            transform: 'translateY(0)'
        }
    },
    textField: {
        margin: "8px 0 16px 0 !important",
        "& label": {
            color: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.6) !important" : "rgba(15, 23, 42, 0.6) !important",
            fontSize: "0.9rem",
        },
        "& label.MuiInputLabel-shrink": {
            background: ({ isDark }) => isDark ? "#111215" : "#ffffff",
            padding: "0 8px !important",
            marginLeft: "-4px"
        },
        "& label.Mui-focused": {
            color: '#E9AE31 !important',
        },
        "& .MuiOutlinedInput-root": {
            background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.03)" : "rgba(0, 0, 0, 0.02)",
            borderRadius: "12px",
            color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
            "& fieldset": {
                borderColor: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.12) !important" : "rgba(0, 0, 0, 0.12) !important",
                borderRadius: "12px",
                transition: "all 0.3s ease",
            },
            "&:hover fieldset": {
                borderColor: "rgba(233, 174, 49, 0.5) !important",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#E9AE31 !important",
                boxShadow: ({ isDark }) => isDark ? "0 0 0 3px rgba(233, 174, 49, 0.2)" : "0 0 0 3px rgba(233, 174, 49, 0.15)"
            },
            "& input": {
                padding: "14px 14px",
                color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
                caretColor: "#E9AE31 !important",
            }
        },
    },
    rootRtl: {
        margin: "8px 0 16px 0 !important",
        "& label": {
            right: 10,
            left: "auto",
            paddingRight: 20,
            color: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.6) !important" : "rgba(15, 23, 42, 0.6) !important",
            fontSize: "0.9rem",
        },
        "& label.MuiInputLabel-shrink": {
            background: ({ isDark }) => isDark ? "#111215" : "#ffffff",
            padding: "0 8px !important",
            marginRight: "24px"
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20
        },
        "& label.Mui-focused": {
            color: '#E9AE31 !important',
        },
        "& .MuiOutlinedInput-root": {
            background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.03)" : "rgba(0, 0, 0, 0.02)",
            borderRadius: "12px",
            color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
            "& fieldset": {
                borderColor: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.12) !important" : "rgba(0, 0, 0, 0.12) !important",
                borderRadius: "12px",
                transition: "all 0.3s ease",
            },
            "&:hover fieldset": {
                borderColor: "rgba(233, 174, 49, 0.5) !important",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#E9AE31 !important",
                boxShadow: ({ isDark }) => isDark ? "0 0 0 3px rgba(233, 174, 49, 0.2)" : "0 0 0 3px rgba(233, 174, 49, 0.15)"
            },
            "& input": {
                padding: "14px 14px",
                color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
                caretColor: "#E9AE31 !important",
            }
        },
    }
}));
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function PaymentSettings() {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const [value, setValue] = React.useState(0);
    const { isDark } = useContext(ThemeContext);
    const classes = useStyles({ isDark });
    const {
        editPaymentMethods
    } = api;

    const [paymentSettings, setPaymentSettings] = useState();
    const [oldPaymentSettings, setOldPaymentSettings] = useState();
    const paymentmethods = useSelector(state => state.paymentmethods);
    const dispatch = useDispatch();
    const settings = useSelector((state) => state.settingsdata.settings);

    useEffect(() => {
        const copyOfProviders = JSON.parse(JSON.stringify(paymentmethods.providers));
        if (paymentmethods.providers) {
            setPaymentSettings(paymentmethods.providers);
            setOldPaymentSettings(copyOfProviders);
        } else {
            setPaymentSettings(null);
            setOldPaymentSettings(null);
        }
    }, [paymentmethods.providers]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleCheck = (e) => {
        let pgName = e.target.name.split("|")[0];
        let pgKey = e.target.name.split("|")[1];
        let ps = Object.assign({}, paymentSettings);;
        ps[pgName][pgKey] = e.target.checked;
        setPaymentSettings(ps);
    }

    const handleText = (e) => {
        let pgName = e.target.name.split("|")[0];
        let pgKey = e.target.name.split("|")[1];
        let ps = Object.assign({}, paymentSettings);;
        ps[pgName][pgKey] = (pgName === 'payulatam') && (pgKey === 'merchantId' || pgKey === 'accountId') && e.target.value.length > 0 ? parseInt(e.target.value) : e.target.value;
        setPaymentSettings(ps);
    }

    const handleSubmit = () => {
        if (settings.AllowCriticalEditsAdmin) {
            dispatch(editPaymentMethods(paymentSettings));
        } else {
            alert(t("demo_mode"))
        }
    }

    const formatLabel = (key) => {
        if (!key) return "";
        return key.split('_')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ');
    };

    return (
        paymentSettings ?
            <Box sx={{ width: '100%', minHeight: '100vh', backgroundColor: isDark ? '#000000' : '#ffffff', padding: '24px' }}>
                <style>{`
                    .MuiFormControlLabel-label {
                        color: ${isDark ? '#e2e8f0' : '#0F172A'} !important;
                        font-family: 'Outfit', sans-serif !important;
                        font-weight: 600 !important;
                        font-size: 15px !important;
                    }
                    .MuiSwitch-switchBase.Mui-checked {
                        color: #E9AE31 !important;
                    }
                    .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
                        background-color: #E9AE31 !important;
                        opacity: 0.5 !important;
                    }
                `}</style>
                <Box sx={{ 
                    borderBottom: isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)', 
                    backgroundColor: isDark ? '#111215' : '#ffffff',
                    borderRadius: '12px',
                    padding: '4px',
                    boxShadow: isDark ? 'none' : '0 2px 8px rgba(0,0,0,0.04)'
                }}>
                    <Tabs value={value} onChange={handleChange} variant="scrollable" aria-label="basic tabs example" className={classes.tabs}>
                        {Object.keys(paymentSettings).map((pgname, index) =>
                            <Tab key={"key" + index} label={t(pgname)} {...a11yProps(index)} />
                        )}
                    </Tabs>
                </Box>
                {Object.keys(paymentSettings).map((pgname, index) =>
                    <TabPanel value={value} index={index} key={"key" + index}>
                        <Box sx={{
                            background: isDark ? "#111215" : "rgba(255, 255, 255, 0.95)",
                            backdropFilter: "blur(12px)",
                            border: isDark ? "1px solid rgba(255, 255, 255, 0.08)" : "1px solid rgba(233, 174, 49, 0.2)",
                            borderRadius: "16px",
                            boxShadow: isDark ? "0 8px 32px 0 rgba(0, 0, 0, 0.37)" : "0 8px 32px 0 rgba(233, 174, 49, 0.05)",
                            padding: { xs: "20px", sm: "32px" },
                            marginTop: "24px"
                        }}>
                            <Grid container spacing={3} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }} >
                                {Object.keys(paymentSettings[pgname]).map((pgKey) => (
                                    <Grid item xs={12} sm={pgKey === 'active' ? 12 : 6} key={"key" + pgKey}>
                                        {paymentSettings[pgname][pgKey] === true || paymentSettings[pgname][pgKey] === false ?
                                            <FormControlLabel
                                                style={{ flexDirection: isRTL === 'rtl' ? 'row' : 'row-reverse', paddingTop: 10, paddingBottom: 15, marginLeft: 5 }}
                                                label={formatLabel(pgKey)}
                                                control={
                                                    <Switch
                                                        checked={paymentSettings[pgname][pgKey]}
                                                        onChange={handleCheck}
                                                        name={pgname + "|" + pgKey}
                                                        color="primary"
                                                    />
                                                }
                                            />
                                            :
                                            <TextField
                                                className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                                                variant="outlined"
                                                margin="none"
                                                type={paymentSettings[pgname][pgKey] === oldPaymentSettings[pgname][pgKey] ? "password" : "text"}
                                                onFocus={(e) => {
                                                    let pgName = e.target.name.split("|")[0];
                                                    let pgKey = e.target.name.split("|")[1];
                                                    let ps = Object.assign({}, paymentSettings);
                                                    ps[pgName][pgKey] = (pgName === 'payulatam') && (pgKey === 'merchantId' || pgKey === 'accountId') && e.target.value.length > 0 ? "" : "";
                                                    setPaymentSettings(ps);
                                                }}
                                                required
                                                fullWidth
                                                id={pgname + "|" + pgKey}
                                                label={formatLabel(pgKey)}
                                                name={pgname + "|" + pgKey}
                                                autoComplete={pgname + "|" + pgKey}
                                                onChange={handleText}
                                                value={paymentSettings[pgname][pgKey]}
                                            />
                                        }
                                    </Grid>
                                ))}
                                <Grid item xs={12}>
                                    <Button
                                        size="lg"
                                        onClick={handleSubmit}
                                        variant="contained"
                                        color="secondaryButton"
                                        className={classes.buttonStyle}
                                    >
                                        {t('submit')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </TabPanel>
                )}
            </Box>
            : null
    );
}